import { db } from "config/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";

export const Watcher = async (id, email) => {
  //   console.log(id);
  //   console.log(email);

  setInterval(async () => {
    const device = await getDoc(doc(db, `users/${email}/devices`, id)).then(
      (doc) => {
        return doc.data();
      }
    );
    const currentDate = new Date(Date.now());
    const date = new Date(device.keepAlive.toDate());

    const TimeDeffierence = currentDate.getTime() - date.getTime();
    const seconds = Math.floor(TimeDeffierence / 1000);
    if (seconds >= 30 && device.battery.level > 5) {
      await setDoc(doc(db, `users/${email}/alerts/${id}`), {
        device: id,
        message: "Device not responding for more than 30 sec",
        viewed: false,
      });
    } else {
      await setDoc(doc(db, `users/${email}/alerts/${id}`), {
        device: id,
        message: "Device is responding",
      });
    }
    console.log("Device Not Responding for", seconds);
  }, 5000);
};
